import * as React from 'react';

import { Container} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import CategoryCard from "../components/CategoryCardM.jsx";
import * as ApiCall from '../ApiCall.jsx';

function EditMenu({categories}) {
  const [state, setState] = React.useState('success');

  const handleMenuDelete = async (e) => {
    const newCategories = categories.filter(category => 
      category.position !== e
    )
    
    try {
      const res = await fetch(`/menu/delete_category/${e}`, {
        method: 'DELETE',
      })
    } catch (err) {
      console.log(err.message);
    }
  };

  if (state === "loading") {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  else  if (state === "success") {
    return (
      <Box sx={{display: 'flex', justifyContent: 'center',  flexDirection: 'column', flexWrap: 'wrap'}}>
        {
          categories.length > 0 &&
            categories.map((category) => (
              <CategoryCard key={category.id} categoryInfo={category} ></CategoryCard>
            ))
        }
      </Box>

    )
  }
}
export default EditMenu;
